module.exports = new __parcel__URL__("retrospective-dark.79188072.png").toString();